<header-title [model]="headerTitle"></header-title>


<div class="container-fluid mt-5">
    <div class="row">
        <div class="offset-lg-1 col-lg-10 col-md-12">

            <section class="panel">
                <div class="panel-body">
                    <div class="container-fluid">
                        <div class="row" style="border-bottom: 1px solid #adc6cd1a;">
                            <div class="col-md-6 mt-3 pl-4">
                                <h3>{{lender?.name}}</h3>
                            </div>
                            <div class="col-md-6 text-right">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mt-1 pl-4">
                                <h4>{{company?.tradingName || company?.legalName}}<span class="mx-3">:</span> {{user?.firstName}} {{user?.lastName}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="panel company-list mt-4">
                <div class="panel-body">
                    <div class="table-responsive" ng-nicescroll nice-option="{cursorcolor: '#e2edff'}">
                        <!--<table class="table table-hover light mb-0">
                            <thead>
                                <tr>
                                    <th width="70%" class="px-4">Name</th>
                                    <th width="15%" class="px-4">Email</th>
                                    <th width="15%" class="text-center px-4">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let u of users;index as i">
                                    <td class="px-4">
                                        {{u.firstName}} {{u.lastName}}
                                    </td>
                                    <td class="px-4">{{u.email}}</td>
                                    <td class="actions text-center px-4">
                                        <a [routerLink]="['/lenders/user',u.id]" title="View"><i class="fas fa-eye"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>-->
                        <table class="table table-hover modules-table light" *ngIf="selectedModules?.length>0">
                            <thead>
                                <tr>
                                    <th>Selected Modules</th>
                                    <th>Customer</th>
                                    <th>Broker</th>
                                    <th>Lender</th>
                                    <th class="text-center">Status</th>
                                    <th class="text-center">Rating</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let m of selectedModules; index as i">
                                    <td>
                                        {{m.moduleDescription}}
                                        <pre style="display:none;">{{m | json}}</pre>
                                    </td>
                                    <td>
                                        {{m.customerSurname}} {{m.customerInitial}}
                                    </td>
                                    <td>
                                        {{m.brokerName}}
                                    </td>
                                    <td>
                                        {{m.lenderName}}
                                    </td>
                                    <td class="text-center">
                                        <span class="far fa-circle text-primary" *ngIf="m.moduleStatus==0" data-toggle="tooltip" title="Not started"></span>
                                        <span class="fas fa-adjust text-primary" *ngIf="m.moduleStatus==1" data-toggle="tooltip" title="In progress"></span>
                                        <span class="fas fa-circle text-primary" *ngIf="m.moduleStatus==2" data-toggle="tooltip" title="Completed"></span>
                                    </td>
                                    <td class="text-center">
                                        <div *ngIf="m.moduleStatus==2">
                                            <span *ngIf="m.weightedScore/(m.nrQuestions*2)*100 < 25" data-toggle="tooltip" title="Positive - Well Done"><span class="fas fa-circle text-success"></span></span>
                                            <span *ngIf="m.weightedScore/(m.nrQuestions*2)*100 >= 25 && m.weightedScore/(m.nrQuestions*2)*100 <= 75" data-toggle="tooltip" title="OK - Needs Attention"><span class="fas fa-circle text-warning"></span></span>
                                            <span *ngIf="m.weightedScore/(m.nrQuestions*2)*100 > 75" data-toggle="tooltip" title="Poor - High Risk"><span class="fas fa-circle text-danger"></span></span>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <button class="btn btn-text p-0" [routerLink]="['/lenders/audit-module/', m.companyAuditId, m.id]" title="View" data-toggle="tooltip" *ngIf="m.moduleStatus==2"><span class="fas fa-eye text-primary"></span></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </div>
    </div>

</div>

